import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';

import * as styles from './index.module.scss';
import { seoHtml } from './constants';
import { SeoHtml } from '../../../../templateElements/seoHtml';

export const SeoSection = () => {
  const contentRef = useRef(null);
  const htmlRef = useRef(null);
  const [isOpen, setOpen] = useState(false);

  /**
   * Автоматически измеряет высоту двух первых элементов в HTML
   */
  useEffect(() => {
    const measure = () => {
      if (!htmlRef.current || !contentRef.current) {
        return;
      }

      const { children } = htmlRef.current;
      if (!children.length || children.length < 2) {
        return;
      }

      const secondElement = children[1];
      const height = secondElement.getBoundingClientRect().height;
      const offset = secondElement.offsetTop;

      contentRef.current.style.setProperty('--collapsed-height', `${height + offset}px`);
    };

    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  return (
    <div className={styles.wrap}>
      <div ref={contentRef} className={classNames(styles.content, isOpen && styles.contentOpen)}>
        <SeoHtml ref={htmlRef} html={seoHtml} />
      </div>

      <button type="button" className={styles.toggle} onClick={() => setOpen((prev) => !prev)}>
        {isOpen ? 'Скрыть' : 'Подробнее'}
      </button>
    </div>
  );
};
